
import Vue from 'vue'
import { isNil } from 'lodash'

interface IData {
  type: 'browser' | 'external'
  endpoint: string
}

export default Vue.extend({
  data: (): IData => ({
    type: 'browser',
    endpoint: '/ip4/127.0.0.1/tcp/5001'
  }),

  computed: {
    origin(): string {
      return document.location.origin
    },

    typeDescription(): string {
      if (this.type === 'external') {
        return 'Use the IPFS node you have installed on your device.'
      }

      return 'A ready-to-use IPFS node in your web browser. Ideal for small files. May have speed and reliability issues.'
    }
  },

  created() {
    if (isNil(this.$accessor.settings.remoteEndpoint)) {
      this.type = 'browser'
    } else {
      this.type = 'external'
      this.endpoint = this.$accessor.settings.remoteEndpoint
    }
  },

  methods: {
    async submit() {
      if (this.type === 'browser') {
        this.$accessor.settings.setRemoteEndpoint(null)
      } else {
        this.$accessor.settings.setRemoteEndpoint(this.endpoint)
      }

      await this.$accessor.settings.save()

      document.location.reload()
    }
  }
})
